import { SVGProps } from 'react'

export const QRcodeSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M860 538.4H968v108h-108zM699.2 216.8h108v108h-108zM358.4 646.4h19.2v19.2l108 108v-235.2H250.4zM646.4 646.4v213.6h-74.4l74.4 74.4v-74.4H752v-213.6zM968 968v-213.6h-108v105.6H752V968zM216.8 216.8h108v108H216.8z' />
      <path d='M197.6 485.6h288V56H56v288l141.6 141.6zM164 164h213.6v213.6H164V164zM646.4 646.4v-108h-108v108zM968 56H538.4v429.6H968V56z m-108 321.6h-213.6V164h213.6v213.6z' />
    </svg>
  )
}
